import { DeparturePriceBucket } from "@b2bportal/air-shopping-api";
import { UseDatepickerProps } from "@datepicker-react/hooks";
import { Deal } from "@hopper-proto/hopper/dealfeed/proto/v1/Deal";
import { DateCalendarContextProvider, PickerType } from "./DateCalendarContext";
import { MonthGrid } from "./MonthGrid";

export const DateCalendar = ({
  startDate,
  endDate,
  focusedInput,
  onDatesChange,
  pickerType = PickerType.RANGE,
  departureDateBuckets = [],
  minBookingDays,
  minBookingDate,
  maxBookingDate,
  deals = [],
  forceDisplayBucketsAndDeals = false,
  initialMonth,
  firstMonth,
  numberOfMonths,
}: Pick<
  UseDatepickerProps,
  | "startDate"
  | "endDate"
  | "focusedInput"
  | "onDatesChange"
  | "minBookingDays"
  | "minBookingDate"
  | "maxBookingDate"
> & {
  pickerType?: PickerType;
  departureDateBuckets?: DeparturePriceBucket[];
  deals?: Deal[];
  forceDisplayBucketsAndDeals?: boolean;
  /** The month the calendar opens on; defaults to the current month. */
  initialMonth?: Date;
  /** The first month the calendar lists; defaults to the current month. */
  firstMonth?: Date;
  /** Months the calendar lists from `firstMonth`; 12 by default. */
  numberOfMonths?: number;
}) => {
  return (
    <DateCalendarContextProvider
      startDate={startDate}
      endDate={endDate}
      focusedInput={focusedInput}
      onDatesChange={onDatesChange}
      pickerType={pickerType}
      departureDateBuckets={departureDateBuckets}
      minBookingDays={minBookingDays}
      minBookingDate={minBookingDate}
      maxBookingDate={maxBookingDate}
      deals={deals}
      forceDisplayBucketsAndDeals={forceDisplayBucketsAndDeals}
      initialMonth={initialMonth}
      firstMonth={firstMonth}
      numberOfMonths={numberOfMonths}
    >
      <MonthGrid />
    </DateCalendarContextProvider>
  );
};
